import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, LogOut, Lock, FileText, ShieldCheck, LifeBuoy, Download, Trash2, ChevronRight } from "lucide-react";
import { toast } from "sonner";
import { Header } from "@/components/MobileShell";
import { Card } from "@/components/kit";
import { useAuth } from "@/context/AuthContext";

function Row({ icon: Icon, label, sub, onClick, danger, testid }) {
  return (
    <button onClick={onClick} className="w-full flex items-center gap-3.5 px-4 py-3.5 text-left hover:bg-[#F8F6F1] transition-colors" data-testid={testid}>
      <Icon className={`h-5 w-5 shrink-0 ${danger ? "text-[#9B4B45]" : "text-[#5F6D66]"}`} strokeWidth={1.7} />
      <div className="flex-1">
        <p className={`font-sans text-sm ${danger ? "text-[#9B4B45]" : "text-[#1F2B26]"}`}>{label}</p>
        {sub && <p className="font-sans text-xs text-[#8A9790] mt-0.5">{sub}</p>}
      </div>
      <ChevronRight className="h-4 w-4 text-[#C9CFC9]" />
    </button>
  );
}

export default function SettingsPage() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const soon = () => toast("Arriving in a later milestone.");

  return (
    <>
      <Header
        title="Settings"
        left={<button onClick={() => navigate("/app/profile")} className="p-1.5 text-[#5F6D66] -ml-1.5" data-testid="settings-back-btn"><ChevronLeft className="h-5 w-5" /></button>}
      />
      <div className="px-6 py-5 space-y-5 pb-10">
        <div>
          <p className="font-sans text-[11px] uppercase tracking-wide text-[#8A9790] px-1 mb-2">Account</p>
          <Card className="overflow-hidden divide-y divide-[#F1EEE7]">
            <div className="px-4 py-3.5">
              <p className="font-sans text-sm text-[#1F2B26]">{user?.email}</p>
              <p className="font-sans text-xs text-[#8A9790] mt-0.5">{user?.email_verified ? "Email verified" : "Email not verified"}</p>
            </div>
            <Row icon={Lock} label="Change password" sub="Send a reset link to your email" onClick={() => navigate("/forgot-password")} testid="settings-change-password" />
          </Card>
        </div>

        <div>
          <p className="font-sans text-[11px] uppercase tracking-wide text-[#8A9790] px-1 mb-2">Privacy & safety</p>
          <Card className="overflow-hidden divide-y divide-[#F1EEE7]">
            <Row icon={ShieldCheck} label="Blocked users" sub="Manage people you've blocked" onClick={soon} testid="settings-blocked" />
            <Row icon={FileText} label="Privacy policy" onClick={soon} testid="settings-privacy" />
            <Row icon={FileText} label="Terms of service" onClick={soon} testid="settings-terms" />
            <Row icon={LifeBuoy} label="Support" onClick={soon} testid="settings-support" />
          </Card>
        </div>

        <div>
          <p className="font-sans text-[11px] uppercase tracking-wide text-[#8A9790] px-1 mb-2">Your data</p>
          <Card className="overflow-hidden divide-y divide-[#F1EEE7]">
            <Row icon={Download} label="Request data export" onClick={soon} testid="settings-export" />
            <Row icon={Trash2} label="Delete account" danger onClick={soon} testid="settings-delete" />
          </Card>
        </div>

        <Card className="overflow-hidden">
          <Row icon={LogOut} label="Sign out" onClick={async () => { await logout(); navigate("/welcome"); }} testid="settings-logout" />
        </Card>

        <p className="text-center font-sans text-xs text-[#B2BAB4] pt-2">Sincerr · Private beta · v1.0</p>
      </div>
    </>
  );
}
